import { PDFDocument, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { fetchPdfWithFallback, drawTextOnPage } from "../../common/pdfPrintList/StaticPdfUtils";

// PDF Path
const PDF = "/static/pdf/printList/cons_pdpa_mepos.pdf";
const Font = "/static/fonts/THSarabunNew-Bold.ttf";

type FormConsentPDPAMePosProps = Partial<{
  detail: Record<string, any>; // -- Type จาก PrintListFormDataHelper
  items: Record<string, any>; // -- Type PatientInfo + additionData จาก PrintListFormDataHelper
}>;

const FormConsentPDPAMePos = async (props: FormConsentPDPAMePosProps) => {
  try {
    const existingPdfBytes = await fetchPdfWithFallback(props.items?.headerInfo?.file_path, PDF);
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // Loading Custom Font
    const fontBytes = await fetch(Font).then((res) => res.arrayBuffer());
    pdfDoc.registerFontkit(fontkit);
    const customFont = await pdfDoc.embedFont(fontBytes);
    
    const pages = pdfDoc.getPages();
    const fontSize = 13;

    const patientAddress = [
      props.items?.present_address?.no || "",
      props.items?.present_address?.name || "",
      props.items?.present_address?.town || "",
      props.items?.present_address?.road || "",
      props.items?.present_address?.street || "",
      props.items?.present_address?.city_label || "",
      props.items?.present_address?.district_label || "",
      props.items?.present_address?.province_label || "",
      props.items?.present_address?.zipcode || "",
    ];

    const formatPatientAddress = patientAddress.filter(item => item).join(" ");

    // Page 1
    const pageOneCoordinates = [
      { text: props.items?.formatVisitDate || "", x: 104, y: 692 },
      { text: props.detail?.formatHn || "", x: 328, y: 692 },
      { text: props.items?.patientFullName || "", x: 86, y: 677 },
      { text: props.items?.formatCitizenNo || "", x: 363, y: 677 },
      { text: props.items?.birthdate || "", x: 103, y: 659 },
      { text: props.items?.full_age || "", x: 386, y: 659 },
      { text: props.detail?.telMobile || "", x: 95, y: 641 },
      { text: props.items?.email || "", x: 263, y: 641 },
      { text: formatPatientAddress || "", x: 85, y: 624 },
      { text: props.items?.relative_address?.owner_name || "", x: 95, y: 606 },
      { text: props.items?.relative_address?.relative || "", x: 381, y: 606 },
      { text: props.items?.underlyingDisease || "", x: 88, y: 588 },
    ];

    drawTextOnPage(pages[0], pageOneCoordinates, customFont, fontSize);

    const modifiedPdfBytes = await pdfDoc.save();
    const getAsBase64 = await pdfDoc.saveAsBase64();
    const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
    const modifiedPdfUrl = URL.createObjectURL(blob);

    return { uint8Array: modifiedPdfBytes, blobUrl: modifiedPdfUrl, blobRaw: blob, base64String: getAsBase64 }
  } catch (error) {
    console.error("Error modifying PDF: ", error);
    return {};
  }
};

export default FormConsentPDPAMePos;
